module.exports = __webpack_public_path__ + "img/page.6d563df3.svg";